import { useParams, useLocation } from "react-router-dom";
import TopUtilityBar from "../sections/TopUtilityBar";
import MainHeader from "../sections/MainHeader";
import Footer from "../sections/Footer";

// Stub CMS-driven static page — Prompt 5 fills the copy.
// Also serves as the /cart route today.
export default function StaticPage() {
  const { slug } = useParams();
  const location = useLocation();
  const isCart = location.pathname === "/cart";
  const title = (slug || (isCart ? "cart" : "page"))
    .replace(/-/g, " ")
    .replace(/\b\w/g, (m) => m.toUpperCase());

  return (
    <div className="min-h-screen bg-white text-[#0A0A0A]">
      <TopUtilityBar />
      <MainHeader />
      <main className="mx-auto max-w-[1440px] px-6 py-16">
        <div className="font-mono text-[11px] uppercase tracking-[0.16em] text-[#8A8A8A]">
          {isCart ? "CART" : "PAGE"}
        </div>
        <h1 className="mt-4 font-display text-[#0A0A0A] text-[36px] md:text-[48px] leading-[0.95]">
          {title}.
        </h1>
        <div className="mt-6 font-sans text-[15px] text-[#8A8A8A] max-w-[640px]">
          {isCart
            ? "Cart drawer arrives in the next release. Add-to-cart mutations to Shopify will be wired here."
            : "Content for this page arrives in the next release."}
        </div>
      </main>
      <Footer />
    </div>
  );
}
